import { Skeleton } from '@/components/ui/skeleton'

const OVERVIEW_CARD_CLASSNAME =
	'flex flex-col gap-4 rounded-4xl border border-neutral-300 p-4'

function MMOverviewLoading() {
	return (
		<div className='flex flex-1 flex-col gap-6 overflow-auto px-10 py-6'>
			{/* Filters */}
			<div className='flex items-center justify-between'>
				<Skeleton height={40} width={340} />
				<Skeleton height={40} width={180} />
			</div>

			{/* Stat cards */}
			<div className='grid grid-cols-4 gap-6'>
				{Array.from({ length: 4 }).map((_, i) => (
					<div
						className={OVERVIEW_CARD_CLASSNAME}
						key={`card-${i + 1}`}
					>
						<div className='flex items-center gap-3'>
							<Skeleton height={32} width={32} />
							<Skeleton height={16} width={120} />
						</div>
						<div className='flex flex-col gap-1 rounded-lg bg-neutral-50 p-4'>
							<Skeleton height={24} width={100} />
							<Skeleton height={14} width={160} />
						</div>
					</div>
				))}
			</div>

			{/* Charts */}
			<div className='grid grid-cols-2 gap-6'>
				{Array.from({ length: 2 }).map((_, i) => (
					<Skeleton height={240} key={`chart-${i + 1}`} />
				))}
			</div>
			<Skeleton height={140} />
		</div>
	)
}

export { MMOverviewLoading }
